module.exports = __webpack_public_path__ + "img/staffordshire_stars_logo.34826104.png";